export const PreclassCheckSettings = {
  CLASS_LOAD_CPU_LOAD_MONITOR_TIME: 2 * 60 * 1000,
  EXTENSION_CPU_LOAD_MONITOR_INTERVAL: 5 * 60 * 1000,
  MIN_GEEKBENCH_SCORE: 1100,
  MIN_MEMORY_GB: 2,
  IDEAL_NUMBER_OF_CORES: 4,
  EXTENSION_URL: "https://chrome.google.com/webstore/detail/jioaiecngdmdgcnmjiappopamjjacjeg",
};
